import React, { Fragment, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { StoreMedicineGroup } from "../../../../api/medicalStore/master/medicineGroupAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

/* ================= VALIDATION ================= */
const schema = yup.object().shape({
  name: yup.string().required("Medicine Group name is required"),
  discountPercentage: yup
    .number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0")
    .max(100, "Discount cannot be more than 100")
    .required("Discount percentage is required")
});

const AddMedicineGroup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  /* ================= SUBMIT ================= */
  const onSubmit = async data => {
    dispatch({ type: "LOADER_START" });
    try {
      const response = await StoreMedicineGroup(data);
      if (response.success) {
        showToast("success", response.message);
        navigate(`/medical-store/master/medicine-group/list`);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error.message || "Something went wrong");
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Medical Store" title="Add Medicine Group" />

      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              {/* ===== HEADER ===== */}
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <h5>Add Medicine Group</h5>
                  <Link to={`/medical-store/master/medicine-group/list`}>
                    <button className="btn btn-primary" id="list">
                      List Medicine Groups
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Medicine Groups
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>

              {/* ===== FORM ===== */}
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    {/* Medicine Group Name */}
                    <div className="col-6">
                      <div className="form-group">
                        <label>Medicine Group Name</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter Medicine Group Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>

                    {/* Discount Percentage */}
                    <div className="col-6">
                      <div className="form-group">
                        <label>Discount Percentage (%)</label>
                        <input
                          className="form-control"
                          type="number"
                          placeholder="Enter Discount Percentage"
                          {...register("discountPercentage")}
                        />
                        {errors.discountPercentage &&
                          <p className="text-danger">
                            {errors.discountPercentage.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ===== FOOTER ===== */}
                <div className="card-footer text-end">
                  <button className="btn btn-primary" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddMedicineGroup;
